import { createI18n } from '@nucleus-commerce/i18n';

import applications from '@/locales/en/applications.json';
import auditLog from '@/locales/en/audit-log.json';
import auth from '@/locales/en/auth.json';
import common from '@/locales/en/common.json';
import diamonds from '@/locales/en/diamonds.json';
import errors from '@/locales/en/errors.json';
import exchangeRates from '@/locales/en/exchange-rates.json';
import operations from '@/locales/en/operations.json';
import organizations from '@/locales/en/organizations.json';
import overview from '@/locales/en/overview.json';
import settings from '@/locales/en/settings.json';
import system from '@/locales/en/system.json';
import tours from '@/locales/en/tours.json';
import users from '@/locales/en/users.json';

export const i18n = createI18n({
  resources: {
    en: {
      common,
      applications,
      auditLog,
      auth,
      diamonds,
      errors,
      exchangeRates,
      operations,
      organizations,
      overview,
      settings,
      system,
      tours,
      users,
    },
  },
  debug: import.meta.env.DEV,
});
